import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../../../styles/colorVariables';

export const useStyles = makeStyles((theme) =>
  createStyles({
    defaultChip: {
      color: '#fff',
      backgroundColor: '#F96767',
      textTransform: 'capitalize',
      fontWeight: 700,
    },
    paidChip: {
      backgroundColor: '#40C369',
    },
    tableCell: {
      '&.MuiTableCell-root': {
        textAlign: 'center',
        padding: '8px 16px',
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRight: `1px solid ${theme.palette.divider}`, 
        fontSize: 14,
        '&:last-child': { // Remove right border from last body cell in row
          borderRight: 0,
        }
      }
    },
    tableRow: {
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      }
    },
    featureCell: {
      '&.MuiTableCell-root': {
        textAlign: 'left',
        fontWeight: 400,
        fontSize: 14,
        color: colorVariables.navy,
      }
    },
    invoiceLink: {
      color: '#25A6EC',
      textDecoration: 'underline',
    }
  }),
);
